"use client";

import { ListingPageLink } from "../ListingPageLink";
import * as styles from "./LoadPrevious.module.scss";

export interface LoadPreviousProps {
	/** The url of the page before, so the link works and is crawled without script. */
	href: string;
	isLoading?: boolean;
	/** Prepends the page before in place; without it the link loads its url. */
	onLoadPrevious?: () => void;
	label?: string;
}

export function LoadPrevious({
	href,
	isLoading = false,
	onLoadPrevious,
	label = "Show previous"
}: LoadPreviousProps): JSX.Element {
	return (
		<div className={styles["load-previous"]} data-component="LoadPrevious">
			<ListingPageLink
				href={href}
				rel="prev"
				label={label}
				isLoading={isLoading}
				onNavigate={onLoadPrevious}
			/>
		</div>
	);
}
